export default "__VITE_ASSET__hRt835vr__"